<template>
  <div>
    <div
      class="mdgridviewpage-bg mainWrap-bg applicationListPage indicatorPage"
    >
      <!-- <HeaderNew></HeaderNew> -->
      <div class="container-fluid maindivWrap">
        <div class="row pt-4 m-0">
          <div class="col-sm-12">
            <div class="wizardCard mb-4">
              <div class="card shadow-sm">
                <div class="card-header text-decoration-none">
                  Select Your Module
                </div>
                <div class="collapse show">
                  <div
                    class="card-body p-0 m-b-0px"
                    style="background-color: transparent !important"
                  >
                    <div
                      class="d-flex homepage-bg"
                      id="wrapper"
                      :style="{
                        backgroundImage: `url(${frmModel.landingPageBGImg})`,
                        backgroundColor: frmModel.landingPageBGImg
                          ? ''
                          : '#7e7877',
                      }"
                    >
                      <div class="overlay"></div>
                      <!-- Sidebar -->
                      <div
                        class="bg-transparent border-right d-none"
                        id="sidebar-wrapper"
                      >
                        <div class="sidebar-heading p-0px">
                          <a
                            href="#"
                            data-toggle="modal"
                            data-target="#uploadAppLogoModal"
                            class="edit-links"
                            style="margin-left: 20px; top: 10px;"
                          >
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                            Change Logo
                          </a>
                          <p
                            class="text-center m-0px"
                            style="margin-top: -28px !important"
                          >
                            <a
                              href="#"
                              data-toggle="modal"
                              data-target="#uploadAppLogoModal"
                            >
                              <img
                                v-if="frmModel.appLogo"
                                :src="frmModel.appLogo"
                                class="img img-fluid brand-logo"
                              />
                              <img
                                v-else
                                src="../assets/img/home/avenir_health.png"
                                class="img img-fluid brand-logo"
                              />
                            </a>
                          </p>
                          <div
                            class="modal fade"
                            id="uploadAppLogoModal"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="uploadAppLogoModalCenterTitle"
                            aria-hidden="true"
                          >
                            <div
                              class="modal-dialog modal-dialog-centered"
                              role="document"
                            >
                              <div class="modal-content">
                                <div
                                  class="modal-header p-10px border-bottom-0 p-l-35px"
                                >
                                  <h6
                                    class="modal-title color-white"
                                    id="uploadAppLogoModalCenterTitle"
                                  >
                                    Upload Application Logo
                                  </h6>
                                  <button
                                    type="button"
                                    class="close color-white"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                  >
                                    <span aria-hidden="true" class="color-white"
                                      >&times;</span
                                    >
                                  </button>
                                </div>
                                <div class="modal-body p-t-5px p-b-0px">
                                  <div class="card bg-transparent">
                                    <div
                                      class="card-body bg-transparent p-t-0px p-b-10px"
                                    >
                                      <div class="row">
                                        <div class="col-lg-12">
                                          <div class="card">
                                            <div class="card-body">
                                              <form>
                                                <div class="form-group row">
                                                  <label
                                                    for="inputPassword"
                                                    class="col-sm-4 col-form-label"
                                                    >Select Logo</label
                                                  >
                                                  <div class="col-sm-8">
                                                    <input
                                                      type="file"
                                                      class="form-control-file p-t-4px"
                                                      style="font-size: 15px"
                                                      name="appLogo"
                                                      accept="image/*"
                                                      @change="onImgChange"
                                                    />
                                                    <div class="img-preview">
                                                      <img
                                                        v-if="frmModel.appLogo"
                                                        :src="frmModel.appLogo"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </form>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="modal-footer p-10px border-top-0 p-r-35px"
                                >
                                  <button
                                    type="button"
                                    class="btn btn-secondary bg-dark-grey color-black"
                                    data-dismiss="modal"
                                  >
                                    Save and Continue
                                  </button>
                                  <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row leadershipmsg-container">
                          <div class="col-lg-12 p-0">
                            <p class="color-white text-uppercase m-0px">
                              <span class="border-bottom-white"
                                >Leadership</span
                              >
                            </p>
                          </div>
                          <div class="col-lg-12 p-0">
                            <div class="media m-t-10px">
                              <a
                                href="#"
                                data-toggle="modal"
                                data-target="#uploadLeadershipLogoModal"
                              >
                                <img
                                  v-if="frmModel.leaderIcon"
                                  :src="frmModel.leaderIcon"
                                  class="img img-fluid brand-logo"
                                />
                                <img
                                  v-else
                                  src="../assets/img/home/user.jpg"
                                  class="mr-3 leaderimg"
                                />
                              </a>
                              <div
                                class="modal fade"
                                id="uploadLeadershipLogoModal"
                                tabindex="-1"
                                role="dialog"
                                aria-labelledby="uploadLeadershipLogoModalCenterTitle"
                                aria-hidden="true"
                              >
                                <div
                                  class="modal-dialog modal-dialog-centered"
                                  role="document"
                                >
                                  <div class="modal-content">
                                    <div
                                      class="modal-header p-10px border-bottom-0 p-l-35px"
                                    >
                                      <h6
                                        class="modal-title color-white"
                                        id="uploadLeadershipLogoModalCenterTitle"
                                      >
                                        Upload Leadership Information
                                      </h6>
                                      <button
                                        type="button"
                                        class="close color-white"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                      >
                                        <span
                                          aria-hidden="true"
                                          class="color-white"
                                          >&times;</span
                                        >
                                      </button>
                                    </div>
                                    <div class="modal-body p-t-5px p-b-0px">
                                      <div class="card bg-transparent">
                                        <div
                                          class="card-body bg-transparent p-t-0px p-b-10px"
                                        >
                                          <div class="row">
                                            <div class="col-lg-12">
                                              <div class="card bg-transparent">
                                                <!-- <div class="card-header bg-dark-grey indicatorlinkheader">

                                                          </div>-->
                                                <div
                                                  class="card-body"
                                                  style="padding-bottom: 10px"
                                                >
                                                  <form>
                                                    <div
                                                      class="form-group row"
                                                      style="
                                                        background: #fff;
                                                        border-radius: 10px;
                                                        padding: 16px;
                                                      "
                                                    >
                                                      <label
                                                        class="col-sm-4 col-form-label"
                                                        >Select Image</label
                                                      >

                                                      <div class="col-sm-8">
                                                        <input
                                                          type="file"
                                                          class="form-control-file p-t-4px"
                                                          style="
                                                            font-size: 15px;
                                                          "
                                                          name="leaderIcon"
                                                          accept="image/*"
                                                          @change="onImgChange"
                                                        />
                                                        <img
                                                          v-if="
                                                            frmModel.leaderIcon
                                                          "
                                                          :src="
                                                            frmModel.leaderIcon
                                                          "
                                                          class="mr-3 leaderimg mt-2"
                                                        />
                                                      </div>
                                                    </div>
                                                    <div
                                                      class="form-group row"
                                                      style="
                                                        background: #fff;
                                                        border-radius: 10px;
                                                        padding: 16px;
                                                      "
                                                    >
                                                      <label
                                                        class="col-sm-4 col-form-label"
                                                        >Designation</label
                                                      >
                                                      <div class="col-sm-8">
                                                        <input
                                                          type="text"
                                                          v-model="
                                                            frmModel.leaderDesignation
                                                          "
                                                          class="form-control"
                                                        />
                                                      </div>
                                                    </div>
                                                    <div
                                                      class="form-group row"
                                                      style="
                                                        background: #fff;
                                                        border-radius: 10px;
                                                        padding: 16px;
                                                        margin-bottom: 0px;
                                                      "
                                                    >
                                                      <label
                                                        class="col-sm-4 col-form-label"
                                                        >Description</label
                                                      >
                                                      <div class="col-sm-8">
                                                        <textarea
                                                          class="form-control"
                                                          v-model="
                                                            frmModel.leaderDesc
                                                          "
                                                          rows="3"
                                                        ></textarea>
                                                      </div>
                                                    </div>
                                                  </form>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="modal-footer p-10px border-top-0 p-r-35px"
                                    >
                                      <button
                                        type="button"
                                        class="btn btn-secondary bg-dark-grey color-black"
                                        data-dismiss="modal"
                                      >
                                        Save
                                      </button>
                                      <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="media-body">
                                <a
                                  href="#"
                                  data-toggle="modal"
                                  data-target="#uploadLeadershipLogoModal"
                                  class="edit-links"
                                  style="margin-left: 20px; top: 10px"
                                >
                                  <i
                                    class="fa fa-pencil"
                                    aria-hidden="true"
                                  ></i>
                                  Change Image and Content
                                </a>
                                <h5
                                  class="m-t-10px leader-designation"
                                  style="margin-top: -10px !important"
                                >
                                  {{ frmModel.leaderDesignation }}
                                </h5>
                              </div>
                            </div>
                            <p class="leader-description">
                              {{ frmModel.leaderDesc }}
                            </p>
                            <p
                              class="text-right leader-description"
                              contenteditable="true"
                            >
                              <span class="border-bottom-white">Read More</span>
                            </p>
                          </div>
                        </div>
                        <div class="row resources-container">
                          <div class="col-lg-12 p-0">
                            <p class="color-white text-uppercase m-0px">
                              <span class="border-bottom-white">Resource</span>
                            </p>
                          </div>
                          <div class="col-lg-12 p-0">
                            <div class="media m-t-10px">
                              <a
                                href="#"
                                data-toggle="modal"
                                data-target="#uploadResourceLogoModal"
                              >
                                <img
                                  src="../assets/img/home/track20.png"
                                  class="mr-3 leaderimg resourceimg"
                                  alt="..."
                                />
                              </a>
                              <div class="media-body">
                                <a
                                  href="#"
                                  data-toggle="modal"
                                  data-target="#uploadResourceLogoModal"
                                  class="edit-links"
                                  style="margin-left: 20px; top: 10px"
                                >
                                  <i
                                    class="fa fa-pencil"
                                    aria-hidden="true"
                                  ></i>
                                  Change Logo and Content
                                </a>
                                <h5
                                  class="leader-designation"
                                  contenteditable="true"
                                  style="margin-top: -40px !important"
                                >
                                  Family Planning Effort Index
                                </h5>
                              </div>
                              <div
                                class="modal fade"
                                id="uploadResourceLogoModal"
                                tabindex="-1"
                                role="dialog"
                                aria-labelledby="uploadResourceLogoModalCenterTitle"
                                aria-hidden="true"
                              >
                                <div
                                  class="modal-dialog modal-dialog-centered"
                                  role="document"
                                >
                                  <div class="modal-content">
                                    <div
                                      class="modal-header p-10px border-bottom-0 p-l-35px"
                                    >
                                      <h6
                                        class="modal-title color-white"
                                        id="uploadResourceLogoModalCenterTitle"
                                      >
                                        Upload Resource Information
                                      </h6>
                                      <button
                                        type="button"
                                        class="close color-white"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                      >
                                        <span
                                          aria-hidden="true"
                                          class="color-white"
                                          >&times;</span
                                        >
                                      </button>
                                    </div>
                                    <div class="modal-body p-t-5px p-b-0px">
                                      <div class="card bg-transparent">
                                        <div
                                          class="card-body bg-transparent p-t-0px p-b-10px"
                                        >
                                          <div class="row">
                                            <div class="col-lg-12">
                                              <div class="card bg-transparent">
                                                <!-- <div class="card-header bg-dark-grey indicatorlinkheader">

                                                          </div>-->
                                                <div
                                                  class="card-body bg-transparent"
                                                  style="padding-bottom: 10px"
                                                >
                                                  <form>
                                                    <div
                                                      class="form-group row"
                                                      style="
                                                        background: #fff;
                                                        border-radius: 10px;
                                                        padding: 16px;
                                                      "
                                                    >
                                                      <label
                                                        for="inputPassword"
                                                        class="col-sm-4 col-form-label"
                                                        >Select Image</label
                                                      >
                                                      <div class="col-sm-8">
                                                        <input
                                                          type="file"
                                                          class="form-control-file p-t-4px"
                                                          style="
                                                            font-size: 15px;
                                                          "
                                                          id="exampleFormControlFile3"
                                                        />
                                                        <img
                                                          src="../assets/img/home/Hopkins.png"
                                                          class="mr-3 leaderimg mt-2"
                                                          alt="..."
                                                        />
                                                      </div>
                                                    </div>
                                                    <div
                                                      class="form-group row"
                                                      style="
                                                        background: #fff;
                                                        border-radius: 10px;
                                                        padding: 16px;
                                                      "
                                                    >
                                                      <label
                                                        for="inputPassword"
                                                        class="col-sm-4 col-form-label"
                                                        >Heading</label
                                                      >
                                                      <div class="col-sm-8">
                                                        <input
                                                          type="text"
                                                          class="form-control"
                                                          id="inputPassword"
                                                          placeholder
                                                        />
                                                      </div>
                                                    </div>
                                                    <div
                                                      class="form-group row"
                                                      style="
                                                        background: #fff;
                                                        border-radius: 10px;
                                                        padding: 16px;
                                                        margin-bottom: 0px;
                                                      "
                                                    >
                                                      <label
                                                        for="inputPassword"
                                                        class="col-sm-4 col-form-label"
                                                        >Description</label
                                                      >
                                                      <div class="col-sm-8">
                                                        <textarea
                                                          class="form-control"
                                                          id="exampleFormControlTextarea1"
                                                          rows="3"
                                                        ></textarea>
                                                      </div>
                                                    </div>
                                                  </form>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      class="modal-footer p-10px border-top-0 p-r-35px"
                                    >
                                      <button
                                        type="button"
                                        class="btn btn-secondary bg-dark-grey color-black"
                                        data-dismiss="modal"
                                      >
                                        Save
                                      </button>
                                      <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p
                              class="leader-description"
                              contenteditable="true"
                            >
                              View the data for countries included in the
                              <span class="color-blue">...View more</span>
                            </p>
                          </div>
                          <div class="col-lg-12 p-0">
                            <div class="media m-t-10px">
                              <a
                                href="#"
                                data-toggle="modal"
                                data-target="#uploadResourceLogoModal"
                              >
                                <img
                                  src="../assets/img/home/Hopkins.png"
                                  class="mr-3 leaderimg resourceimg"
                                  alt="..."
                                />
                              </a>
                              <div class="media-body">
                                <h5
                                  class="leader-designation"
                                  contenteditable="true"
                                >
                                  The Lives Saved Tool (LiST)
                                </h5>
                              </div>
                            </div>
                            <p
                              class="leader-description"
                              contenteditable="true"
                            >
                              An evidence-based tool for estimating
                              <span class="color-blue">...View more</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <!-- /#sidebar-wrapper -->
                      <!-- Page Content -->
                      <div id="page-content-wrapper" class>
                        <!-- <a
                                    href="#"
                                    class="pull-left mr-2"
                                    data-toggle="modal"
                                    data-target="#uploadLogoImageModal"
                                  > -->

                        <!-- <img
                                      src="../assets/img/logo_front_new.png"
                                      class="img-responsive-sm c_logo aviner_logo1"
                                      alt="Dure Technology"

                                    /> -->
                        <img
                          v-if="frmModel.appLogo"
                          :src="frmModel.appLogo"
                          class="img-responsive-sm c_logo aviner_logo1"
                        />
                        <img
                          v-else
                          src="../assets/img/logo_front_new.png"
                          class="img-responsive-sm c_logo aviner_logo1"
                          alt="Dure Technology"
                        />
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#uploadLogoImageModal"
                          class="edit-links"
                          style="margin-left: 20px; top: 10px; left: 1px"
                        >
                          <i class="fa fa-pencil" aria-hidden="true"></i> Change
                          Logo Image
                        </a>
                        <!-- </a> -->
                        <div
                          class="modal fade"
                          id="uploadLogoImageModal"
                          tabindex="-1"
                          role="dialog"
                          aria-labelledby="uploadLogoImageModalCenterTitle"
                          aria-hidden="true"
                        >
                          <div
                            class="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div class="modal-content">
                              <div
                                class="modal-header p-10px border-bottom-0 p-l-35px"
                              >
                                <h6
                                  class="modal-title color-white"
                                  id="uploadBackgroundImageModalCenterTitle"
                                >
                                  Upload Logo Image
                                </h6>
                                <button
                                  type="button"
                                  class="close color-white"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true" class="color-white"
                                    >&times;</span
                                  >
                                </button>
                              </div>
                              <div class="modal-body p-t-5px p-b-0px">
                                <div class="card bg-transparent">
                                  <div
                                    class="card-body bg-transparent p-t-0px p-b-10px"
                                  >
                                    <div class="row">
                                      <div class="col-lg-12">
                                        <div class="card">
                                          <div class="card-body">
                                            <form>
                                              <div class="form-group row">
                                                <label
                                                  class="col-sm-4 col-form-label"
                                                  >Select Image</label
                                                >
                                                <div class="col-sm-8">
                                                  <input
                                                    type="file"
                                                    class="form-control-file p-t-4px"
                                                    style="font-size: 15px"
                                                    name="appLogo"
                                                    accept="image/*"
                                                    @change="onImgChange"
                                                  />
                                                </div>
                                                <div class="img-preview">
                                                  <img
                                                    v-if="frmModel.appLogo"
                                                    :src="frmModel.appLogo"
                                                  />
                                                </div>
                                              </div>
                                            </form>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="modal-footer p-10px border-top-0 p-r-35px"
                              >
                                <button
                                  type="button"
                                  class="btn btn-secondary bg-dark-grey color-black"
                                  data-dismiss="modal"
                                >
                                  Save and Continue
                                </button>
                                <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <a
                          href="#"
                          class="pull-right mr-2"
                          data-toggle="modal"
                          data-target="#uploadBackgroundImageModal"
                        >
                          <a
                            href="#"
                            data-toggle="modal"
                            data-target="#uploadBackgroundImageModal"
                            class="edit-links"
                            style="margin-left: 20px; top: 10px; right: 20px"
                          >
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                            Change Background Image
                          </a>
                        </a>
                        <div
                          class="modal fade"
                          id="uploadBackgroundImageModal"
                          tabindex="-1"
                          role="dialog"
                          aria-labelledby="uploadBackgroundImageModalCenterTitle"
                          aria-hidden="true"
                        >
                          <div
                            class="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div class="modal-content">
                              <div
                                class="modal-header p-10px border-bottom-0 p-l-35px"
                              >
                                <h6
                                  class="modal-title color-white"
                                  id="uploadBackgroundImageModalCenterTitle"
                                >
                                  Upload Background Image
                                </h6>
                                <button
                                  type="button"
                                  class="close color-white"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true" class="color-white"
                                    >&times;</span
                                  >
                                </button>
                              </div>
                              <div class="modal-body p-t-5px p-b-0px">
                                <div class="card bg-transparent">
                                  <div
                                    class="card-body bg-transparent p-t-0px p-b-10px"
                                  >
                                    <div class="row">
                                      <div class="col-lg-12">
                                        <div class="card">
                                          <div class="card-body">
                                            <form>
                                              <div class="form-group row">
                                                <label
                                                  class="col-sm-4 col-form-label"
                                                  >Select Image</label
                                                >
                                                <div class="col-sm-8">
                                                  <input
                                                    type="file"
                                                    class="form-control-file p-t-4px"
                                                    style="font-size: 15px"
                                                    name="landingPageBGImg"
                                                    accept="image/*"
                                                    @change="onImgChange"
                                                  />
                                                </div>
                                                <div class="img-preview">
                                                  <img
                                                    v-if="
                                                      frmModel.landingPageBGImg
                                                    "
                                                    :src="
                                                      frmModel.landingPageBGImg
                                                    "
                                                  />
                                                </div>
                                              </div>
                                            </form>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="modal-footer p-10px border-top-0 p-r-35px"
                              >
                                <button
                                  type="button"
                                  class="btn btn-secondary bg-dark-grey color-black"
                                  data-dismiss="modal"
                                >
                                  Save and Continue
                                </button>
                                <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="container-fluid landingpage-maincontainer">
                          <a
                            href="#"
                            data-toggle="modal"
                            data-target="#uploadMainContentModal"
                            class="edit-links"
                            style="
                              top: 60px;
                              right: 20px;
                              text-align: center !important;
                              width: 100%;
                            "
                          >
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                            Change Content
                          </a>
                          <div
                            class="modal fade"
                            id="uploadMainContentModal"
                            tabindex="-1"
                            role="dialog"
                            aria-labelledby="uploadResourceLogoModalCenterTitle"
                            aria-hidden="true"
                          >
                            <div
                              class="modal-dialog modal-dialog-centered"
                              role="document"
                            >
                              <div class="modal-content">
                                <div
                                  class="modal-header p-10px border-bottom-0 p-l-35px"
                                >
                                  <h6
                                    class="modal-title color-white"
                                    id="uploadResourceMainContentCenterTitle"
                                  >
                                    Upload Content
                                  </h6>
                                  <button
                                    type="button"
                                    class="close color-white"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                  >
                                    <span aria-hidden="true" class="color-white"
                                      >&times;</span
                                    >
                                  </button>
                                </div>
                                <div class="modal-body p-t-5px p-b-0px">
                                  <div class="card bg-transparent">
                                    <div
                                      class="card-body bg-transparent p-t-0px p-b-10px"
                                    >
                                      <div class="row">
                                        <div class="col-lg-12">
                                          <div class="card bg-transparent">
                                            <div
                                              class="card-body bg-transparent"
                                              style="padding-bottom: 10px"
                                            >
                                              <form>
                                                <div
                                                  class="form-group row"
                                                  style="
                                                    background: #fff;
                                                    border-radius: 10px;
                                                    padding: 16px;
                                                  "
                                                >
                                                  <label
                                                    class="col-sm-4 col-form-label"
                                                    >Heading</label
                                                  >
                                                  <div class="col-sm-8">
                                                    <input
                                                      type="text"
                                                      class="form-control"
                                                      v-model="
                                                        frmModel.landingPageTitle
                                                      "
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  class="form-group row"
                                                  style="
                                                    background: #fff;
                                                    border-radius: 10px;
                                                    padding: 16px;
                                                    margin-bottom: 0px;
                                                  "
                                                >
                                                  <label
                                                    class="col-sm-4 col-form-label"
                                                    >Description</label
                                                  >
                                                  <div class="col-sm-8">
                                                    <textarea
                                                      class="form-control"
                                                      v-model="
                                                        frmModel.landingPageDesc
                                                      "
                                                      rows="3"
                                                    ></textarea>
                                                  </div>
                                                </div>
                                              </form>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="modal-footer p-10px border-top-0 p-r-35px"
                                >
                                  <button
                                    type="button"
                                    class="btn btn-secondary bg-dark-grey color-black"
                                    data-dismiss="modal"
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <input type="text" class="mt-4 color-white f-w-100 text-left w-100 headingText" v-model="frmModel.landingPageTitle" title="Click to edit">
                                    <textarea v-model="frmModel.landingPageDesc" class="landing-desc" maxlength="450" rows="4" title="Click to edit"></textarea>-->
                          <h1
                            class="mt-4 color-white f-w-100 text-left w-100"
                            contenteditable="true"
                          >
                            {{ frmModel.landingPageTitle }}
                          </h1>
                          <p class="color-white" contenteditable="true">
                            {{ frmModel.landingPageDesc }}
                          </p>
                          <div class="row m-t-40px">
                            <!-- <div class="col-lg-1 col-sm-6 d-sm-none d-lg-block"></div> -->
                            <div
                              class="col"
                              v-if="settings.countryName.toLowerCase() === ''"
                            >
                              <div
                                class="card text-center ministerial-dashboard-homepageblock bg-transparent"
                              >
                                <div class="card-header uppercase">
                                  Ministerial
                                  <br />Dashboard
                                </div>
                                <div class="card-body">
                                  <p class="m-0">
                                    <img
                                      src="../assets/img/home/min-dashboard-homeicon.png"
                                      class="img img-fluid"
                                    />
                                  </p>
                                  <div
                                    class="card-footer"
                                    style="padding-top: 15px !important"
                                  >
                                    <a
                                      href="#/md-gridview"
                                      class="color-white uppercase"
                                      >View More</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col"
                              v-if="
                                settings.countryName.toLowerCase() === 'nepal'
                              "
                            >
                              <div
                                class="card text-center ministerial-dashboard-homepageblock bg-transparent"
                              >
                                <div class="card-header uppercase">
                                  FAMILY PLANNING
                                  <br />SERVICES
                                </div>
                                <div class="card-body">
                                  <p class="m-0">
                                    <img
                                      src="../assets/img/home/min-dashboard-homeicon.png"
                                      class="img img-fluid"
                                    />
                                  </p>
                                  <div
                                    class="card-footer"
                                    style="padding-top: 15px !important"
                                  >
                                    <a
                                      href="#/md-gridview"
                                      class="color-white uppercase"
                                      >View More</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col"
                              v-if="
                                settings.countryName.toLowerCase() === 'nepal'
                              "
                            >
                              <div
                                class="card text-center ad_sexual-dashboard-homepageblock bg-transparent"
                              >
                                <div class="card-header uppercase">
                                  ADOLESCENT SEXUAL
                                  <br />REPROD. HEALTH
                                </div>
                                <div class="card-body">
                                  <p class="m-0">
                                    <img
                                      src="../assets/img/home/min-dashboard-homeicon.png"
                                      class="img img-fluid"
                                    />
                                  </p>
                                  <div
                                    class="card-footer"
                                    style="padding-top: 15px !important"
                                  >
                                    <a
                                      href="#/md-gridview"
                                      class="color-white uppercase"
                                      >View More</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col"
                              v-if="settings.countryName.toLowerCase() === ''"
                            >
                              <div
                                class="card text-center analytical-dashboard-homepageblock bg-transparent"
                              >
                                <div class="card-header uppercase">
                                  Analytical
                                  <br />Dashboard
                                </div>
                                <div class="card-body">
                                  <p class="m-0">
                                    <img
                                      src="../assets/img/home/ana-dashboard-homeicon.png"
                                      class="img img-fluid"
                                    />
                                  </p>
                                  <div
                                    class="card-footer"
                                    style="padding-top: 15px !important"
                                  >
                                    <a
                                      href="#/analytical-geo"
                                      class="color-white uppercase"
                                      >View More</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col">
                              <div
                                class="card text-center interactive-dashboard-homepageblock bg-transparent"
                              >
                                <div class="card-header uppercase">
                                  Interactive
                                  <br />Analytics
                                </div>
                                <div class="card-body">
                                  <p class="m-0">
                                    <img
                                      src="../assets/img/home/int-dashboard-homeicon.png"
                                      class="img img-fluid"
                                    />
                                  </p>
                                  <div
                                    class="card-footer"
                                    style="padding-top: 15px !important"
                                  >
                                    <a
                                      href="#/create-interactive-analysis"
                                      class="color-white uppercase"
                                      >View More</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col"
                              v-if="settings.countryName.toLowerCase() === ''"
                            >
                              <div
                                class="card text-center dataquality-dashboard-homepageblock bg-transparent"
                              >
                                <div class="card-header uppercase">
                                  Data quality
                                  <br />review
                                </div>
                                <div class="card-body">
                                  <p class="m-0">
                                    <img
                                      src="../assets/img/home/dataquality-dashboard-homeicon.png"
                                      class="img img-fluid"
                                    />
                                  </p>
                                  <div
                                    class="card-footer"
                                    style="padding-top: 15px !important"
                                  >
                                    <a
                                      href="#/data-quality"
                                      class="color-white uppercase"
                                      >View More</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col">
                              <div
                                class="card text-center favorites-dashboard-homepageblock bg-transparent"
                              >
                                <div class="card-header uppercase">
                                  Saved
                                  <br />Favorites
                                </div>
                                <div class="card-body">
                                  <p class="m-0">
                                    <img
                                      src="../assets/img/home/favorites-dashboard-homeicon.png"
                                      class="img img-fluid"
                                    />
                                  </p>
                                  <div
                                    class="card-footer"
                                    style="padding-top: 15px !important"
                                  >
                                    <a
                                      href="#/bookmark-chart"
                                      class="color-white uppercase"
                                      >View More</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- <div class="col-lg-1 col-sm-6 d-sm-none d-lg-block"></div> -->
                          </div>
                        </div>
                      </div>

                      <!-- /#page-content-wrapper -->
                    </div>
                    <div class="container-fluid footerSection pl-0 pr-0">
                      <div id="footer">
                        <footer style="position: static">
                          <div
                            class="d-flex justify-content-between align-items-center mblViewfooter"
                          >
                            <div class="social-icon">
                              <ul>
                                <li><p class="mr-2 mb-0">Follow us :</p></li>
                                <li>
                                  <a href="#" class="social_a_tag"
                                    ><span
                                      class="fa fa-facebook social-icon-fa"
                                    ></span
                                  ></a>
                                </li>
                                <li>
                                  <a href="#" class="social_a_tag"
                                    ><span
                                      class="fa fa-twitter social-icon-fa"
                                    ></span
                                  ></a>
                                </li>
                                <li>
                                  <a href="#" class="social_a_tag"
                                    ><span
                                      class="fa fa-youtube-play social-icon-fa"
                                    ></span
                                  ></a>
                                </li>
                                <li>
                                  <a href="#" class="social_a_tag"
                                    ><span
                                      class="fa fa-instagram social-icon-fa"
                                    ></span
                                  ></a>
                                </li>
                              </ul>
                            </div>
                            <a
                              href="#"
                              data-toggle="modal"
                              data-target="#uploadUrlModal"
                              class="edit-links"
                              style="margin-left: 0px; top: 0px; right: 54px;"
                            >
                              <i class="fa fa-pencil" aria-hidden="true"></i>
                              Upload URL
                            </a>
                            <div class="row socialicons-container m-t-20">
                              <div
                                class="col-lg-3 p-0 text-center border-right-white col-sm-3"
                              >
                                
                                <div
                                  class="modal fade"
                                  id="uploadUrlModal"
                                  tabindex="-1"
                                  role="dialog"
                                  aria-labelledby="uploadUrlModalCenterTitle"
                                  aria-hidden="true"
                                >
                                  <div
                                    class="modal-dialog modal-dialog-centered"
                                    role="document"
                                  >
                                    <div class="modal-content">
                                      <div
                                        class="modal-header p-10px border-bottom-0 p-l-35px"
                                      >
                                        <h6
                                          class="modal-title color-white"
                                          id="uploadUrlModalCenterTitle"
                                        >
                                          Upload Url
                                        </h6>
                                        <button
                                          type="button"
                                          class="close color-white"
                                          data-dismiss="modal"
                                          aria-label="Close"
                                        >
                                          <span
                                            aria-hidden="true"
                                            class="color-white"
                                            >&times;</span
                                          >
                                        </button>
                                      </div>
                                      <div class="modal-body p-t-5px p-b-0px">
                                        <div class="card bg-transparent">
                                          <div
                                            class="card-body bg-transparent p-t-0px p-b-10px"
                                          >
                                            <div class="row">
                                              <div class="col-lg-12">
                                                <div class="card">
                                                  <!-- <div class="card-header bg-dark-grey indicatorlinkheader">

                                                        </div>-->
                                                  <div class="card-body">
                                                    <form>
                                                      <div
                                                        class="form-group row"
                                                      >
                                                        <label
                                                          for="inputFacebook"
                                                          class="col-sm-4 col-form-label"
                                                          >Facebook</label
                                                        >
                                                        <div class="col-sm-8">
                                                          <input
                                                            type="text"
                                                            v-model="
                                                              frmModel.fbLink
                                                            "
                                                            class="form-control"
                                                            id="inputFacebook"
                                                            placeholder="http://www.example.com"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div
                                                        class="form-group row"
                                                      >
                                                        <label
                                                          for="inputInstagram"
                                                          class="col-sm-4 col-form-label"
                                                          >Instagram</label
                                                        >
                                                        <div class="col-sm-8">
                                                          <input
                                                            type="text"
                                                            v-model="
                                                              frmModel.instaLink
                                                            "
                                                            class="form-control"
                                                            id="inputInstagram"
                                                            placeholder="http://www.example.com"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div
                                                        class="form-group row"
                                                      >
                                                        <label
                                                          for="inputTwitter"
                                                          class="col-sm-4 col-form-label"
                                                          >Twitter</label
                                                        >
                                                        <div class="col-sm-8">
                                                          <input
                                                            type="text"
                                                            v-model="
                                                              frmModel.twitterLink
                                                            "
                                                            class="form-control"
                                                            id="inputTwitter"
                                                            placeholder="http://www.example.com"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div
                                                        class="form-group row"
                                                      >
                                                        <label
                                                          for="inputYoutube"
                                                          class="col-sm-4 col-form-label"
                                                          >Youtube</label
                                                        >
                                                        <div class="col-sm-8">
                                                          <input
                                                            type="text"
                                                            v-model="
                                                              frmModel.youTubeLink
                                                            "
                                                            class="form-control"
                                                            id="inputYoutube"
                                                            placeholder="http://www.example.com"
                                                          />
                                                        </div>
                                                      </div>
                                                    </form>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="modal-footer p-10px border-top-0 p-r-35px"
                                      >
                                        <button
                                          type="button"
                                          class="btn btn-secondary bg-dark-grey color-black"
                                          data-dismiss="modal"
                                        >
                                          Save
                                        </button>
                                        <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              
                            </div>
                            <p class="copyRightText mb-1">
                              <small
                                >Copyright
                                <i
                                  class="fa fa-copyright"
                                  aria-hidden="true"
                                ></i>
                                2010-2020 Dure Technologies, All rights
                                reserved</small
                              >
                            </p>

                            <div class="c_div">
                              <span class="text-dark"
                                ><small>Powered By: </small></span
                              >

                              <template>
                                <img
                                  src="../assets/img/logo_svg_dt.svg"
                                  class="img-fluid c_logo ml-1"
                                  alt="Dure Technology"
                                />
                              </template>
                            </div>
                          </div>
                        </footer>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="bottomSubmitbtn float-right mb-4">
              <button class="btn btn-newprimary">
                <i
                  class="fa fa-angle-double-left pr-2 text-white"
                  aria-hidden="true"
                ></i>
                Back
              </button>

              <button class="btn btn-newprimary">
                Save
                <i
                  class="fa fa-angle-double-right pl-2 text-white"
                  aria-hidden="true"
                ></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <training-footer></training-footer> -->
  </div>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import ApiServices from "../service/ApiServices";
import moment from "moment";
import swal from "sweetalert2";
export default {
  data() {
    return {
      frmModel: {
        appId: 0,
        appUserId: "",
        category: "Dashboard",
        createdBy: "",
        createdOn: "",
        updatedBy: "",
        updatedOn: "",
        startingYear: "2010",
        appName: "",
        appDesc: "",
        defaultColorTheme: "#212832",
        landingPageLogo: "",
        landingPageTitle: "Avenir Health",
        landingPageDesc:
          "Avenir Health, formerly Futures Institute, was founded in 2006 as a global health organization that works to enhance social and economic development by providing tools and technical assistance in policy, planning, resource allocation and evaluation. In particular, we focus on developing and implementing demographic, epidemiological and costing models for long-range planning to assist with setting goals, strategies, and objectives.",
        landingPageBGImg: "",
        leaderIcon: "",
        leaderDesignation: "Director for the Centre of M&E and Advocacy",
        leaderDesc:
          "Dr. Xyz Jorge joined Avenir Health in 2009. She currently leads activities that focus on monitoring of health programs...",
        fbLink: "",
        instaLink: "",
        twitterLink: "",
        youTubeLink: "",
        defaultLanguage: "en",
        defaultLanguageLocale: "en",
        debugging: false,
        debuggingLevel: "API",
        appLogo: "",
        lastyear: "2012",
        layout: "1",
        modules: [],
        type: "sample",
        country: "",
        countryuid: "",
        userid: "",
        username: "",
        useruid: "",
        authparam: "",
        userRole: "",
        uploadedExcelName: "",
      },
      uploadedExcelName: "",
      uploadedExcel: "",
      isFirstTabValid: false,
      loggedInUserProfile: null,
      downloadTemplateUrl:
        "https://fppnepal.duredemos.com/uploadedfiles/fpp(Nepal).xlsx",
      visible: false,
      date: new Date(),
      years: [],
      settings: settings,
      baseUrl: "http://localhost:8080/dhis/",
      dashboardUrl: "api/apps/Avenir-Generic/index.html#/",
      selected: "staticData",

      templateDetails: {
        templateName: "",
        templateDesc: "",
        fileType: "",
        numSheetsToRead: "", //internal
      },
      isProceed: false,
      cumulativeList: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      dimensionTypeList: [
        { text: "Please select dimension type", value: null, disabled: true },
        { text: "DISAGGREGATION", value: "disaggregation" },
        { text: "ATTRIBUTE", value: "attribut" },
      ],
      domainTypeList: [
        { text: "Please select domain type", value: null, disabled: true },
        { text: "AGGREGATE", value: "aggregate" },
        { text: "TRACKER", value: "attribut" },
      ],
      aggregationTypeList: [
        { text: "Please select aggregation type", value: null, disabled: true },
        { text: "SUM", value: "SUM" },
        { text: "AVERAGE", value: "AVERAGE" },
        { text: "AVERAGE SUM ORG UNIT", value: "AVERAGE_SUM_ORG_UNIT" },
        { text: "LAST", value: "LAST" },
        { text: "LAST AVERAGE ORG UNIT", value: "LAST_AVERAGE_ORG_UNIT" },
        { text: "FIRST", value: "FIRST" },
        { text: "FIRST AVERAGE ORG UNIT", value: "FIRST_AVERAGE_ORG_UNIT" },
        { text: "COUNT", value: "COUNT" },
        { text: "STDDEV", value: "STDDEV" },
        { text: "VARIANCE", value: "VARIANCE" },
        { text: "MIN", value: "MIN" },
        { text: "MAX", value: "MAX" },
        { text: "NONE", value: "NONE" },
        { text: "CUSTOM", value: "CUSTOM" },
        { text: "DEFAULT", value: "DEFAULT" },
      ],
      valueTypeList: [
        { text: "Please select value type", value: null, disabled: true },
        { text: "TEXT", value: "TEXT" },
        { text: "LONG TEXT", value: "LONG_TEXT" },
        { text: "LETTER", value: "LETTER" },
        { text: "PHONE NUMBER", value: "PHONE_NUMBER" },
        { text: "EMAIL", value: "EMAIL" },
        { text: "BOOLEAN", value: "BOOLEAN" },
        { text: "TRUE ONLY", value: "TRUE_ONLY" },
        { text: "DATE", value: "DATE" },
        { text: "DATETIME", value: "DATETIME" },
        { text: "TIME", value: "TIME" },
        { text: "NUMBER", value: "NUMBER" },
        { text: "UNIT INTERVAL", value: "UNIT_INTERVAL" },
        { text: "PERCENTAGE", value: "PERCENTAGE" },
        { text: "INTEGER", value: "INTEGER" },
        { text: "INTEGER POSITIVE", value: "INTEGER_POSITIVE" },
        { text: "INTEGER NEGATIVE", value: "INTEGER_NEGATIVE" },
        { text: "INTEGER ZERO OR POSITIVE", value: "INTEGER_ZERO_OR_POSITIVE" },
        { text: "TRACKER ASSOCIATE", value: "TRACKER_ASSOCIATE" },
        { text: "USERNAME", value: "USERNAME" },
        { text: "COORDINATE", value: "COORDINATE" },
        { text: "ORGANISATION UNIT", value: "ORGANISATION_UNIT" },
        { text: "AGE", value: "AGE" },
        { text: "URL", value: "URL" },
        { text: "FILE RESOURCE", value: "FILE_RESOURCE" },
        { text: "IMAGE", value: "IMAGE" },
      ],
      periodTypeList: [
        { text: "Please select period type", value: null, disabled: true },
        { text: "Daily", value: "Daily" },
        { text: "Weekly", value: "Weekly" },
        { text: "Weekly Wednesday", value: "WeeklyWednesday" },
        { text: "Weekly Thursday", value: "WeeklyThursday" },
        { text: "Weekly Saturday", value: "WeeklySaturday" },
        { text: "Weekly Sunday", value: "WeeklySunday" },
        { text: "Bi Weekly", value: "BiWeekly" },
        { text: "Monthly", value: "Monthly" },
        { text: "Bi Monthly", value: "BiMonthly" },
        { text: "Quarterly", value: "Quarterly" },
        { text: "Six Monthly", value: "SixMonthly" },
        { text: "Six Monthly April", value: "SixMonthlyApril" },
        { text: "Six Monthly Nov", value: "SixMonthlyNov" },
        { text: "Yearly", value: "Yearly" },
        { text: "Financial April", value: "FinancialApril" },
        { text: "Financial July", value: "FinancialJuly" },
        { text: "Financial Oct", value: "FinancialOct" },
        { text: "Financial Nov", value: "FinancialNov" },
      ],
      periodFrequencyList: [
        {
          text: "Please select period frequency type",
          value: null,
          disabled: true,
        },
      ],
      calenderTypeList: [
        // {text:"Please select calender type", value: null, disabled: true}
        {
          text: "International Fixed Calendar",
          value: "International Fixed Calendar",
        },
      ],
      sheetDetails: {
        sheetName: "",
        readFrom: "",
        valueRowPosition: "",
        valueColPosition: "",
        serviceName: "",
        valueSingleColumn: false,
        baseOrg: "",
        level1Vertical: "true", //true/false
        parentOrgRowPosition: "",
        parentOrgColPosition: "",
        parentRecords: "read_all", //internal
        baseOrgIgnoreRows: "",
        baseOrgIgnoreCols: "",
        level1SingleCell: "", //add in UI true/false

        childLevelOrg: "",
        childOrgVertical: "true",
        childOrgRowPosition: "",
        childOrgColPosition: "",
        childRecords: "read_all", //internal
        childOrgIgnoreRows: "",
        childOrgIgnoreCols: "",
        level2SingleCell: "",

        childLevelOrg1: "",
        childOrgVertical1: "true",
        childOrgRowPosition1: "",
        childOrgColPosition1: "",
        childRecords1: "read_all", //internal
        childOrgIgnoreRows1: "",
        childOrgIgnoreCols1: "",
        level2SingleCell1: "",

        childLevelOrg2: "",
        childOrgVertical2: "true",
        childOrgRowPosition2: "",
        childOrgColPosition2: "",
        childRecords2: "read_all", //internal
        childOrgIgnoreRows2: "",
        childOrgIgnoreCols2: "",
        level2SingleCell2: "",

        childLevelOrg3: "",
        childOrgVertical3: "true",
        childOrgRowPosition3: "",
        childOrgColPosition3: "",
        childRecords3: "read_all", //internal
        childOrgIgnoreRows3: "",
        childOrgIgnoreCols3: "",
        level2SingleCell3: "",

        categoryName: "",
        categoryVertical: "true", //true/false
        categoryRowPosition: "",
        categoryColPosition: "",
        categoryRecords: "read_all", //International
        categoryIgnoreCols: "",
        categoryIgnoreRows: "",
        catComboDimensionType: "",
        //primary category fields
        categoryPrimaryColPosition: "",
        categoryPrimaryRowPosition: "",
        categoryPrimaryName: "",
        categoryPrimary: "",
        categoryPrimaryVertical: "true",

        dataElementVertical: "true", //true/false
        dataElementRowPosition: "",
        dataElementColPosition: "",
        dataElementRecords: "read_all", //International
        dataElementIgnoreCols: "",
        dataElementIgnoreRows: "",
        dataElementDomainType: "",
        dataElementAggregationType: "",
        dataElementValueType: "",
        cumulative: false,
        allCumulative: "true", //true/false
        cumulitives: [{ value: "" }],
        dataEltsNoCats: [{ value: "" }],
        dataelementUidAvailable: false,
        dataelementUidVertical: "true",
        dataelementUidColPosition: "",
        dataelementUidRowPosition: "",

        dataGroup: "",
        dataElementGrpVertical: "true",
        dataeltGrpRowPosition: "",
        dataeltGrpColPosition: "",
        dataElementGrpRecords: "read_all", //internal
        dataElementGrpIgnoreRows: "",
        dataElementGrpIgnoreCols: "",

        periodType: "",
        periodFrequency: "",
        calenderType: "International Fixed Calendar",
        periodVertical: "true",
        periodRowPosition: "",
        periodColPosition: "",
        periodRecords: "read_all", //internal
        periodIgnoreCols: "",
        periodIgnoreRows: "",
        periodSingleCell: "",
      },
      allSavedTemplates: [],
      listOfTemplates: [],
      isUpload: false,
      uploadTemplateID: null,
      isEdit: false,
      isAppEdit: false,
      perPage: 3,
      currentPage: 1,
      isAddNewTemplate: false,
      sheets: [],
      uploadTemplateName: "",
    };
  },
  created() {
    ApiServices.theme(this.frmModel.defaultColorTheme);
  },
  watch: {
    "templateDetails.numSheetsToRead": function (newValue, oldValue) {
      if (!this.isEdit) {
        this.sheets = [];
        this.$nextTick(() => {
          for (let i = 0; i < newValue; i++) {
            let details = JSON.parse(JSON.stringify(this.sheetDetails));
            this.sheets.push(details);
          }
        });
      }
    },
    selected(newValue) {
      this.isEdit = false;
      this.resetDynamicForm();
      if (newValue === "staticData") {
        this.isUpload = false;
      }
    },
  },
  computed: {
    templatesList() {
      return this.listOfTemplates.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    rows() {
      return this.listOfTemplates.length;
    },
  },
  methods: {
    addNewSpecific(index) {
      // console.log(index)
      // console.log(this.sheets)
      this.sheets = this.sheets.map((s, i) => {
        if (i === index) {
          return { ...s, cumulitives: s.cumulitives.concat({ value: "" }) };
        } else {
          return s;
        }
      });
    },
    removeNewSpecific(index, elemInd) {
      this.sheets = this.sheets.map((s, i) => {
        if (i === index) {
          var newS = s.cumulitives.filter((s, i) => i !== elemInd);
          return { ...s, cumulitives: newS };
        } else {
          return s;
        }
      });
    },
    removeElem(index, elemInd) {
      this.sheets = this.sheets.map((s, i) => {
        if (i === index) {
          // console.log("s.dataEltsNoCats",s.dataEltsNoCats);
          // console.log(index);
          // console.log(elemInd);
          var newS = s.dataEltsNoCats.filter((s, i) => i !== elemInd);
          // console.log("newS",newS);
          return { ...s, dataEltsNoCats: newS };
        } else {
          return s;
        }
      });
    },
    addNewelem(index) {
      // console.log(index)
      // console.log(this.sheets)
      this.sheets = this.sheets.map((s, i) => {
        if (i === index) {
          // console.log(s.dataEltsNoCats);
          return {
            ...s,
            dataEltsNoCats: s.dataEltsNoCats.concat({ value: "" }),
          };
        } else {
          return s;
        }
      });
    },
    resetDynamicForm() {
      this.templateDetails = {
        templateName: "",
        templateDesc: "",
        fileType: "",
        numSheetsToRead: "",
      };
      this.editTemplateSheets = [];
      this.isProceed = false;
    },
    addNewTemplate() {
      this.isAddNewTemplate = true;
      this.isUpload = false;
      this.isEdit = false;
      this.resetDynamicForm();
    },
    editTemplate(templateId) {
      // console.log(templateId)
      this.isEdit = true;
      this.isAddNewTemplate = true;
      this.isUpload = false;
      let templates = JSON.parse(JSON.stringify(this.allSavedTemplates)).filter(
        (t) => t.templateId === templateId
      );
      // console.log(templates)
      // console.log(templates[0])
      this.templateDetails = {
        templateName: templates[0].templateName
          ? templates[0].templateName
          : "",
        templateDesc: templates[0].templateDesc
          ? templates[0].templateDesc
          : "",
        fileType: templates[0].fileType ? templates[0].fileType : "",
        numSheetsToRead: templates[0].numSheetsToRead
          ? templates[0].numSheetsToRead
          : "",
      };

      this.sheets = templates.map((t, index) => {
        let updatedObj = Object.assign(
          JSON.parse(JSON.stringify(this.sheetDetails)),
          t
        );
        // console.log(t.dataEltsNoCats);
        // console.log(t.cumulitives);
        // console.log(updatedObj.cumulitives);
        // console.log(updatedObj.dataEltsNoCats);
        if (!updatedObj.allCumulative) {
          updatedObj.cumulitives =
            updatedObj.cumulitives && updatedObj.cumulitives.length
              ? updatedObj.cumulitives.map((c) => ({ value: c }))
              : [];
        }
        if (updatedObj.dataEltsNoCats.length > 0) {
          updatedObj.dataEltsNoCats =
            updatedObj.dataEltsNoCats && updatedObj.dataEltsNoCats.length
              ? updatedObj.dataEltsNoCats.map((c) => ({ value: c }))
              : [];
        }
        // console.log(updatedObj);
        return JSON.parse(JSON.stringify(updatedObj));
      });
      // console.log(this.sheets)
      this.isProceed = true;
    },
    uploadData(templateId) {
      this.isUpload = true;
      this.isAddNewTemplate = false;
      this.uploadTemplateID = templateId;
      this.uploadTemplateName = this.templatesList.find(
        (t) => t.templateId === templateId
      ).name;
    },
    deleteData(templateId) {
      this.$root.loading = true;
      ApiServices.RestPostCall(
        "api/avenir/uploadData/deleteUploadTemplate?templateId=" + templateId
      ).then((response) => {
        let isTemplate = this.listOfTemplates.find(
          (lt) => lt.templateId === templateId
        );
        this.listOfTemplates.splice(isTemplate.index - 1, 1);
        this.$root.loading = false;
        this.getTemplates();
        if (this.isEdit) {
          this.isEdit = false;
          this.isAddNewTemplate = false;
        }
      });
    },
    submitTemplate() {
      this.$root.loading = true;
      // console.log("submit template called", this.sheets)
      let sheets = this.sheets.map((s) => ({
        ...s,
        cumulitives:
          s.cumulitives && s.cumulitives.length
            ? s.cumulitives.map((c) => c.value)
            : [],
        dataEltsNoCats:
          s.dataEltsNoCats && s.dataEltsNoCats.length
            ? s.dataEltsNoCats.map((c) => c.value)
            : [],
        ...this.templateDetails,
      }));
      // console.log(sheets);
      ApiServices.RestPostCall(
        "api/avenir/uploadData/updateUploadTemplate",
        sheets
      ).then((response) => {
        // console.log("response",response)
        this.$root.loading = false;
        this.isProceed = false;
        this.getTemplates();
        this.templateDetails = {
          // id: 937,
          // templateId: "gpkFxNSwRtx",
          templateName: "",
          templateDesc: "",
          fileType: "",
          numSheetsToRead: "",
        };
        if (this.isEdit) {
          this.isEdit = false;
          this.isAddNewTemplate = false;
        }
        if (this.isUpload) {
          this.isUpload = false;
          this.uploadTemplateName = "";
        }
      });
    },
    getTemplates() {
      ApiServices.RestGetCall(
        "api/avenir/uploadData/getAllUploadTemplates"
      ).then((response) => {
        // console.log("all templates",response)
        this.allSavedTemplates = response.uploadTemplates;
        let index = 0;
        if (this.listOfTemplates.length > 0) {
          let maxIndex = this.listOfTemplates.map((t) => t.index);
          index = Math.max(...maxIndex);
        }
        response.uploadTemplates.forEach((t, i) => {
          let isTemplate = this.listOfTemplates.find(
            (lt) => lt.templateId === t.templateId
          );
          if (!isTemplate) {
            index += 1;
            this.listOfTemplates.push({
              index,
              name: t.templateName,
              templateId: t.templateId,
              lastUpdated: moment.utc(t.lastUpdated).format("MM/DD/YYYY"),
              userName: t.userName,
            });
          }
        });
      });
    },
    proceed() {
      this.isProceed = true;
      // console.log(this.templateDetails);
    },
    getClass() {
      // if(settings.countryName.toLowerCase() === 'nepal'){
      //   return 'newBlack-theme'
      // }else{
      //   return 'newBlue-theme'
      // }
      if (this.frmModel.defaultColorTheme === "#212832") {
        return "newBlack-theme";
      } else if (this.frmModel.defaultColorTheme === "#66e093") {
        return "newBlue-theme";
      } else if (this.frmModel.defaultColorTheme === "#25984b") {
        return "newGreen-theme";
      }
    },
    random(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    onComplete: function () {
      //console.log(this.$refs.inputfile);
      //debugger;
      this.$root.loading = true;
      if (!this.isAppEdit) {
        this.frmModel.userid = this.loggedInUserProfile.userid;
        this.frmModel.username = this.loggedInUserProfile.username;
        this.frmModel.useruid = this.loggedInUserProfile.useruid;
        this.frmModel.authparam = this.loggedInUserProfile.authparam;
        this.frmModel.appUserId = this.loggedInUserProfile.useruid;
        this.frmModel.userRole = this.loggedInUserProfile.userrole;
        this.frmModel.createdBy =
          this.loggedInUserProfile.firstname +
          " " +
          this.loggedInUserProfile.lastname;
        this.frmModel.createdOn = moment(new Date()).format("lll");
      }
      this.frmModel.updatedBy =
        this.loggedInUserProfile.firstname +
        " " +
        this.loggedInUserProfile.lastname;
      this.frmModel.updatedOn = moment(new Date()).format("lll");
      console.log("this.frmModel", this.frmModel);
      // return

      let formData = new FormData();
      formData.append("file", this.uploadedExcel);
      // to be remove later
      console.log(this.frmModel);
      let test = {
        ...this.frmModel,
        //defaultColorTheme: this.frmModel.defaultColorTheme.split("#")[1]
      };
      if (this.selected === "dynamicData") {
        test.templateId = this.uploadTemplateID;
      }
      formData.append("inputjson", JSON.stringify(test));
      // console.log(JSON.stringify(test));
      /*for (var value of formData.values()) {
        console.log(value);
      }*/
      //return;
      //let headers = {'Content-Type': 'multipart/form-data',Authorization: 'Basic YWRtaW46ZGlzdHJpY3Q='};
      var that = this;
      ApiServices.RestPostMaltipart(
        "api/avenir/uploadData/read",
        formData
      ).then((res) => {
        this.$root.loading = false;
        if (res.status.toLocaleLowerCase() == "success") {
          this.$swal
            .fire({
              //title: 'Are you sure, you want to quit?',
              text: "Successfully saved!",
              confirmButtonColor: "#3085d6",
              icon: "success",
              showCancelButton: true,
              confirmButtonText: "Go to Dashboard",
              cancelButtonText: "Ok",
            })
            .then((result) => {
              console.log(result.value);
              if (result.value) {
                //window.location = this.dashboardUrl;
                let url = this.dashboardUrl;
                if (process.env.NODE_ENV !== "production") {
                  url = "http://localhost:8080/#/";
                }
                // let url = 'http://localhost:8080/#/'
                // console.log(this.isAppEdit)
                if (this.isAppEdit) {
                  url =
                    url +
                    `?appId=${this.$route.query.appId}&appUserId=${this.$route.query.appUserId}`;
                  // this.$nextTick(() => this.isAppEdit = false)
                } else {
                  url = url + `?appId=${res.appId}&appUserId=${res.appUserId}`;
                }
                window.open(url, "_blank");
              }
            });
        } else {
          /*this.$swal({
            icon: 'error',
            text: res.message
            });*/
          let errorTable = "";
          if (res.data.length > 1) {
            errorTable = `<table class="table table-striped">
                <thead>
                    <tr>
                        <th>Excel Sheet Row No</th>
                        <th style="text-align: left;">Error Details</th>
                    </tr>
                </thead>
                <tbody>`;
            for (var i in res.data) {
              //console.log(res.data[i])

              for (var j in res.data[i].errors) {
                if (j == 0) {
                  errorTable += `<tr><td>` + res.data[i].rowno + `</td>`;
                } else {
                  errorTable += `<tr><td></td>`;
                }

                errorTable +=
                  `<td style="text-align: left; text-transform: capitalize;">` +
                  res.data[i].errors[j] +
                  `</td></tr>`;
              }
            }
            errorTable += `</tbody></table>`;
          } else {
            errorTable = `<p>` + res.data[0] + `</p>`;
          }

          this.$swal.fire({
            title: "Alert!",
            width: "90%",
            icon: "error",
            html: errorTable,
            showCloseButton: true,
            //focusConfirm: false,
            confirmButtonText: "Ok",
            confirmButtonAriaLabel: "Ok",
            showCancelButton: false,
            //cancelButtonText: '<i class="fa fa-thumbs-down"></i>',
            //cancelButtonAriaLabel: 'Thumbs down'
          });
        }

        that.$refs.inputfile.value = null;
        this.frmModel.uploadedExcelName = "";
        this.uploadedExcelName = "";
        this.uploadedExcel = "";
        this.uploadTemplateID = null;
        if (this.isUpload) {
          this.isUpload = false;
          this.uploadTemplateName = "";
        }
      });
    },
    validateFirstTab: function () {
      return this.$refs.form.validate();
    },
    validateSecondTab: function () {
      return true;
      //return this.$refs.secondTabForm.validate();
    },
    validateThirdTab: function () {
      return true;
      //return this.$refs.thirdTabForm.validate();
    },
    onFileChange(file) {
      this.frmModel.uploadedExcelName = file.target.files[0].name;
      this.uploadedExcelName = file.target.files[0].name;
      this.uploadedExcel = file.target.files[0];
    },
    onImgChange(e) {
      const file = e.target.files[0];
      const imgSrc = e.target.name;
      console.log(imgSrc);
      this.getBase64String(file).then((res) => {
        //  console.log(res);
        this.frmModel[imgSrc] = res;
      });
      console.log(this.frmModel[imgSrc]);
      console.log(this.frmModel.landingPageLogo);
    },
    getBase64String(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    getConfig(appId, appUserId) {
      ApiServices.getSavedConfig(
        `${appUserId}_${appId}_applicationModule_en`
      ).then((response) => {
        console.log("response", response);
        this.frmModel = response.data;
      });
    },
  },
  mounted() {
    this.baseUrl = ApiServices.getBaseUrl();
    this.getTemplates();
    this.dashboardUrl = this.baseUrl + this.dashboardUrl;
    //this.$root.loading = true;
    if (localStorage.getItem("userProfile")) {
      this.loggedInUserProfile = JSON.parse(
        localStorage.getItem("userProfile")
      );
    }

    if (this.$route.query.appId && this.$route.query.appUserId) {
      this.getConfig(this.$route.query.appId, this.$route.query.appUserId);
      this.isAppEdit = true;
    }
    // console.log(this.loggedInUserProfile);

    let year = this.date.getFullYear();
    let newyear = year - 10;

    for (var i = newyear; i < year + 1; i++) {
      this.years.push(i);
    }
    this.years.reverse();
  },
};
</script>

<style lang="scss" scoped>
.mdgridviewpage-bg {
  // background-color: #38a1c1;
  background-color: #f4f4f4 !important;
  background-image: none;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  // padding: 20px 40px;
}

body.green-theme .mdgridviewpage-bg {
  background-color: #006600;
  background: url("../assets/img/green-bg.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  padding: 20px 40px;
}

.mainform-holder {
  background: #fff;
  -webkit-box-shadow: -2px 0 5px 0 rgba(204, 204, 204, 1);
  -moz-box-shadow: -2px 0 5px 0 rgba(204, 204, 204, 1);
  box-shadow: -2px 0 5px 0 rgba(204, 204, 204, 1);
  border-radius: 10px;
  padding: 60px;
}

.homepage-bg {
  /*background: url("../assets/img/home/Avenir-health-home.jpg") no-repeat;*/
  // background-image: linear-gradient(
  //     0deg,
  //     rgba(0, 0, 0, 0.5),
  //     rgba(0, 0, 0, 0.5)
  //   ),
  //   url("../assets/img/home/avenirbg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.socialicons-container {
  position: absolute;
}
/*.config-icon-container {
  width: 100px;
  height: auto;
}*/

.modRadio .config-icon-container {
  width: 100px;
  height: 100px;
}

#benchmarking .tabs .card-header {
  background-color: rgba(0, 0, 0, 0.03);
}

#sidebar-wrapper {
  position: relative;
}

.modRadio.colorSelect {
  margin-bottom: 30px;
}

.overlay {
  position: absolute;
  top: 56px;
  left: 0;
  height: calc(100% - 56px);
  width: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 0 0 10px 10px;
}

.edit-links {
  z-index: 14;
  position: relative;
  color: #fff;
  font-size: 14px;
  .fa {
    color: #fff;
  }
}
.img-preview img {
  width: 180px !important;
  margin-top: 20px;
}
.headingText {
  background: transparent;
  border: none;
  font-size: 2.5rem;
  font-weight: 100;
  font-color: #ffffff;
  padding: 0;
}

.landing-desc {
  background: transparent;
  color: #fff;
  border: none;
  width: 100%;
}
.col-form-label {
  font-size: 14px;
}
.vue-form-wizard .wizard-btn {
  font-weight: 400;
}
.card {
  background-color: #f4f4f4;
}
// .col-lg-1,
// .col-lg-10,
// .col-lg-11,
// .col-lg-12,
// .col-lg-2,
// .col-lg-3,
// .col-lg-4,
// .col-lg-5,
// .col-lg-6,
// .col-lg-7,
// .col-lg-8,
// .col-lg-9,
// .col-md-1,
// .col-md-10,
// .col-md-11,
// .col-md-12,
// .col-md-2,
// .col-md-3,
// .col-md-4,
// .col-md-5,
// .col-md-55,
// .col-md-6,
// .col-md-7,
// .col-md-8,
// .col-md-9,
// .col-sm-1,
// .col-sm-10,
// .col-sm-11,
// .col-sm-12,
// .col-sm-2,
// .col-sm-3,
// .col-sm-4,
// .col-sm-5,
// .col-sm-6,
// .col-sm-7,
// .col-sm-8,
// .col-sm-9,
// .col-xs-1,
// .col-xs-10,
// .col-xs-11,
// .col-xs-12,
// .col-xs-2,
// .col-xs-3,
// .col-xs-4,
// .col-xs-5,
// .col-xs-6,
// .col-xs-7,
// .col-xs-8,
// .col-xs-9 {
//   padding-right: 15px !important;
//   padding-left: 15px !important;
// }
select {
  -moz-appearance: none;
  /* Firefox */
  -webkit-appearance: none;
  /* Safari and Chrome */
  appearance: none;
  -moz-appearance: none !important;
}
.select-wrapper {
  position: relative;
}

.select-wrapper:after {
  font-family: FontAwesome;
  content: "\f0d7";
  font-size: 16px;
  position: absolute;
  top: 8px;
  right: 14px;
  color: #676767;
  pointer-events: none;
}
.bg-light-purple {
  background-color: #3662a8 !important;
}
.mb-0 > button:after {
  display: none;
}
.mainCard {
  height: 80vh;
  border: 0;
}
.upload_data_tab #v-pills-tab {
  height: 80vh;
  background: #373a3f !important;
}
.upload_data_tab .nav-link {
  background: #373a3f;
  color: #f4f4f4;
  font-size: 16px;
}
.upload_data_tab .nav-link.active {
  border-radius: 0;
  background-color: #fff;
  border: 0;
  border-left: 6px solid #fe5868;
  font-weight: 500;
  color: #4c4c4c !important;
}
.upload_data_tab .nav-link:hover {
  background-color: #d4d4d4;
  border-color: transparent;
  border-radius: 0;
  color: #4c4c4c !important;
  border-left: 6px solid #fe5868;
}
.upload_data_tab {
  background: #373a3f;
  border-radius: 0 6px 6px 0;
}
.upload_data_tab .tab-content {
  background-color: #fff !important;
  border-radius: 0 6px 6px 0;
}
.upload_data_tab .radioLabelName {
  font-size: 1.2em;
  line-height: 1;
}
.upload_data_tab .iconGroup {
  display: block;
  // position: absolute;
  // right: 20px;
  // top: 15px;
}
.upload_data_tab tbody tr {
  position: relative;
}
.upload_data_tab tr:hover > .iconGroup {
  display: inline-block;
}
.upload_data_tab .iconGroup .fa {
  font-size: 1.2em;
  margin: auto 12px;
  transition: all 0.5s;
  color: #c5c5c5;
  cursor: pointer;
}
.upload_data_tab .iconGroup .fa:hover {
  color: #5e5e5e;
}
.tableCard {
  background-color: #fff;
  border-radius: 0 !important;
}
.subTab {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.subTab .nav-link.active {
  border-left: 0;
  font-weight: 500;
}
.subTab .nav-link {
  background: transparent;
  color: #373a3f;
  font-size: 14px;
  font-weight: 200;
  transform: all 0.5s;
}
.subTab .nav-link:hover {
  background-color: transparent;
  border-color: transparent;
  border-radius: 0;
  color: #373a3f !important;
  border-left: 0;
  font-weight: 500;
}
.formSection {
  height: calc(100vh - 250px);
  overflow: hidden;
  overflow-y: scroll;
}
.border_bottom_grey {
  border-bottom: 2px solid #212832;
}
.addTemp_btn {
}
.upload_data_tab h6 {
  font-size: 0.875rem;
}
.mainRadiobtn {
  font-size: 0.875rem !important;
}
// .upload_data_tab .pure-checkbox input[type="radio"] + label:before{
//   border: 1px solid #333;
//   width: 12px;
//   height: 12px;
//   margin-top: -8px;
// }
// .upload_data_tab .pure-checkbox input[type="radio"] + label{
//   padding-left: 1.4em;
// }
// .upload_data_tab .pure-checkbox input[type="radio"] + label:after{
//   top: 48%;
//   left: 2px;
//   width: 10px;
//   height: 10px;
//   margin-top: -5px;
// }
.upload_data_tab .col-form-label {
  font-size: 0.84rem;
}
.upload_data_tab .form-control {
  // color: #7e8084;
  color: #434445;
  font-weight: 300 !important;
}
.upload_data_tab .btn-success {
  color: #fff;
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}
.newGreen-theme {
  .upload_data_tab {
    background: #1a4728;
    border-radius: 0 6px 6px 0;
  }
  .upload_data_tab #v-pills-tab {
    height: 80vh;
    background: #1a4728 !important;
  }
  .upload_data_tab .nav-link {
    background: #1a4728;
    color: #f4f4f4;
    font-size: 16px;
  }
  .upload_data_tab .nav-link.active {
    border-radius: 0;
    background-color: #fff;
    border: 0;
    border-left: 6px solid #fe5868;
    font-weight: 500;
    color: #4c4c4c !important;
  }
  .upload_data_tab .nav-link:hover {
    background-color: #f4f4f4;
    border-color: transparent;
    border-radius: 0;
    color: #4c4c4c !important;
    border-left: 6px solid #fe5868;
  }
  .upload_data_tab .tab-content {
    background-color: #ffffff !important;
    border-radius: 0 6px 6px 0;
  }
  .sandbox_setup.sheetsNumber
    .wizard-nav
    li.active
    .wizard-icon-circle.tab_shape
    .wizard-icon-container {
    background-color: #f4f4f4 !important;
  }
  .subTab {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
  }
  .subTab .nav-link.active {
    border-left: 0 !important;
    font-weight: 500 !important;
  }
  .subTab .nav-link {
    background: transparent !important;
    color: #373a3f !important;
    font-size: 14px !important;
    font-weight: 200 !important;
    transform: all 0.5s !important;
  }
  .subTab .nav-link:hover {
    background-color: transparent !important;
    border-color: transparent !important;
    border-radius: 0 !important;
    color: #373a3f !important;
    border-left: 0 !important;
    font-weight: 500 !important;
  }
}
.footerSection #footer footer {
  background-color: #fff !important;
  border-radius: 0 0 10px 10px;
}
.homepage-bg .modal-content {
  background-color: #828282 !important;
}
.homepage-bg .modal-content .modal-footer button {
  color: #fff !important;
}
.wizard-tab-container {
  .card {
    background-color: #fff;
  }
}
.c_div .c_logo {
  width: 140px !important;
  padding-left: 0;
  // padding-right: 1%;
}
.wizardCard .card .card-body {
  border: 0;
}
</style>
